var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTgNotice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_354_528)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#279EDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 35.4C28.1 30.7 35.3 27.6 38.9 26.1C49.2 21.8 51.4 21.1 52.7 21C53 21 53.7 21.1 54.1 21.4C54.5 21.7 54.6 22.1 54.6 22.4C54.6 22.7 54.7 23.4 54.7 23.9C54.1 29.8 51.7 44 50.5 50.6C50 53.4 49 54.3 48 54.4C45.8 54.6 44.2 53 42.1 51.6C38.8 49.5 37 48.1 33.8 46C30.1 43.6 32.5 42.3 34.6 40.1C35.1 39.5 44.6 30.9 44.8 30.1C44.8 30 44.8 29.6 44.6 29.4C44.4 29.2 44.1 29.3 43.8 29.3C43.5 29.4 38.3 32.8 28.2 39.6C26.7 40.6 25.4 41.1 24.2 41.1C22.9 41.1 20.3 40.3 18.4 39.7C16.1 38.9 14.2 38.5 14.4 37.3C14.7 36.8 15.6 36.1 17.3 35.4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_354_528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgNotice);
export default __webpack_public_path__ + "static/media/tg_notice.0cf7cc782efc4e6e3222fd0b907d0937.svg";
export { ForwardRef as ReactComponent };